import { GET_DYNAMIC_LIST_SETTING_SUCCESS } from '../constants';

export default function dynamicListSettings(state = {}, action) {
    switch (action.type) {
        case GET_DYNAMIC_LIST_SETTING_SUCCESS:
            return {
                ...state,
                data: action.payload.dynamicListSettingsData,
            };
        default:
            return state;
    }
}
